export const bankCardListMockData = [
  {
    id: 1,
    cardTitle: "Salary Card",
    balance: 2500,
    info: {
      abbv: "CB",
      bankName: "Universal Bank",
      number: "5489 7452 5726 9827",
      expiry: "04/24",
      type: "mastercard",
      cvv: 322,
    },
  },
  {
    id: 2,
    bankTitle: "Saving Card",
    balance: 1500,
    info: {
      abbv: "AE",
      bankName: "American Express",
      number: "3000 4232 7685 5555",
      expiry: "02/26",
      type: "visa",
      cvv: 322,
    },
  },
];
